import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransparentBg = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 342,
	height: 64,
	viewBox: "0 0 342 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M32 1H310C317.571 1 323.148 1.00243 327.423 1.57715C331.669 2.14803 334.48 3.26718 336.606 5.39355C338.733 7.51993 339.852 10.331 340.423 14.5771C340.998 18.852 341 24.4294 341 32C341 39.5706 340.998 45.148 340.423 49.4229C339.852 53.669 338.733 56.4801 336.606 58.6064C334.48 60.7328 331.669 61.852 327.423 62.4229C323.148 62.9976 317.571 63 310 63H32C24.4294 63 18.852 62.9976 14.5771 62.4229C10.331 61.852 7.51993 60.7328 5.39355 58.6064C3.26718 56.4801 2.14803 53.669 1.57715 49.4229C1.00243 45.148 1 39.5706 1 32C1 24.4294 1.00243 18.852 1.57715 14.5771C2.14803 10.331 3.26718 7.51993 5.39355 5.39355C7.51993 3.26718 10.331 2.14803 14.5771 1.57715C18.852 1.00243 24.4294 1 32 1Z",
		stroke: "white",
		strokeWidth: 2
	})
});
export default SvgTransparentBg;
